import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthenticationService } from 'app/service/authentication.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
    user: any;
    constructor(
        private authService: AuthenticationService,
        private router: Router
    ) { }

    ngOnInit() {
        this.authService.getUserinfo().subscribe(res => {
            this.user = res;
        });
    }

    onLogoutClick() {
        if (confirm('Are you sure you want to logout?')) {
            this.authService.logout();
            this.router.navigate(['/admin']);
            return false;
        }
    }
}
